// extracted by mini-css-extract-plugin
export default {"active":"_2CGe8jkGPwH1qcVyy06XCe"};